// FLAGS: none
// Captures the five `utm_*` query parameters into `sessionStorage`, strips them from the visible URL, and
// holds them until the PostHog identify call consumes and deletes them.
export class UtmService {
  static readonly utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];

  static readonly utmSessionStorageIdentifier = "utmParams";

  static saveUtmToSessionStorage(searchParams: URLSearchParams): void {
    const utmParams: Record<string, string> = {};
    const entries = Array.from(searchParams.entries());

    entries.forEach(([paramKey, paramValue]) => {
      const matchedKey = UtmService.utmKeys.find(
        (utmKey) => utmKey === paramKey.toLowerCase(),
      );

      if (matchedKey && paramValue) {
        utmParams[matchedKey] = paramValue;
        searchParams.delete(paramKey);
      }
    });

    if (Object.keys(utmParams).length > 0) {
      sessionStorage.setItem(
        UtmService.utmSessionStorageIdentifier,
        JSON.stringify(utmParams),
      );
    }
  }

  static removeUtmParamsFromUrl(searchParams: URLSearchParams): void {
    const url = new URL(window.location.href);

    UtmService.utmKeys.forEach((key) => {
      searchParams.delete(key);
    });

    const remainingSearchParams = searchParams.toString()
      ? `?${searchParams.toString()}`
      : "";

    const newRelativeUrl = `${url.pathname}${remainingSearchParams}${url.hash}`;
    window.history.replaceState(null, "", newRelativeUrl);
  }

  static getUtmFromSessionStorage(): Record<string, string> | null {
    const utmParamsJson = sessionStorage.getItem(
      UtmService.utmSessionStorageIdentifier,
    );
    if (utmParamsJson) {
      const utmParams = JSON.parse(utmParamsJson) as Record<string, string>;
      return utmParams;
    }
    return null;
  }

  static removeUtmFromSessionStorage(): void {
    sessionStorage.removeItem(UtmService.utmSessionStorageIdentifier);
  }
}
